/**
 * @module DEV / Component - Carousel Debug Component
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { Component, AfterViewInit, Input, OnDestroy } from '@angular/core';
import { Carousel } from './models/carousel.interface';
import { CarouselItem } from './models/item.interface';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { TEXT_CONSTANTS } from '@support/shared/constants/device.constants';

@Component({
  selector: 'tmo-marketing-carousel',
  templateUrl: './marketing-carousel.component.html',
  styleUrls: ['../../../../../../style-sheets/components/carousel.component.scss'],
})
export class MarketingCarouselComponent implements AfterViewInit, OnDestroy {
  // @TOOD include match media
  @Input() public css: string;
  @Input() public imageSwithingTime: number;
  // @Input() public carouselImages: CarouselItem[];
  // @TODO include match media
  @Input() public showInTablet: boolean;
  @Input() public showInMobile: boolean;
  @Input() public showInDesktop: boolean;
  /**
   * Numeriv var to set the time interval when autoplay is On
   */
  public nextPhotoInterval: number;
  /**
   * Boolean to stop the carousel to play again from begining
   */
  public noLoopSlides: boolean;
  /**
   * Items to display @Todo: make the HTML templetes available
   */
  public itemsToDisplay: number;
  /**
   * Boolean to set Autoplay active
   */
  public autoPlayCarousel: boolean;
  /**
   * Boolean to show carousel in devices
   */
  public showMarketCarousel: boolean;
  public deviceType: string;
  public textConst: Object;
  /**
   * Variable to hold array of objects meaning the slides
   */
  private slides: Object[];

  /**
   * Start adding the slides from a json object fetch
   */
  public constructor(private commonUtilService: CommonUtilService) {
    const interval: number = 3000;
    this.nextPhotoInterval = interval;
    this.noLoopSlides = false;
    this.itemsToDisplay = 1;
    this.autoPlayCarousel = true;
    this.showMarketCarousel = true;
    this.textConst = TEXT_CONSTANTS;
    this.slides = [];
  }
  public ngAfterViewInit(): void {}
  /**
   * Unsubscribes for all subscriptions
   */
  public ngOnDestroy(): void {}

  /**
   * Sets the data for the specified component. This is required as the AEM module will use this method to populate
   * component data
   * @param data Input data for AEM component
   */
  public setData(data: Carousel): void {
    if (this.validate(data)) {
      const imageCount = data.carouselImages.length;
      for (let i = 0; i < imageCount; i++) {
        this.slides.push(data.carouselImages[i]);
      }
    }
    // Assign optionals
    this.css = data.css || '';
    this.imageSwithingTime = data.imageSwithingTime ? data.imageSwithingTime : -1;
    this.nextPhotoInterval = this.imageSwithingTime;
    this.showInTablet = data.showInTablet || true;
    this.showInMobile = data.showInMobile || true;
    this.showInDesktop = data.showInDesktop || true;
    this.slides.forEach((slide: CarouselItem) => {
      if (!slide.carouselImageMobile || !slide.carouselImageTablet) {
        slide.carouselImageMobile = slide.carouselImageDesktop;
        slide.carouselImageTablet = slide.carouselImageDesktop;
      }
      if (!slide.showInSlide) {
        const index = this.slides.indexOf(slide);
        this.slides = this.slides.splice(index, 1);
      }
    });
    this.showMarketCarousel = this.isShowMarketCarousel();
  }

  public isShowMarketCarousel(): boolean {
    this.deviceType = this.commonUtilService.checkDevice();
    return (
      (this.deviceType === TEXT_CONSTANTS.DEVICE_DESKTOP && this.showInDesktop) ||
      (this.deviceType === TEXT_CONSTANTS.DEVICE_MOBILE && this.showInMobile) ||
      (this.deviceType === TEXT_CONSTANTS.DEVICE_TABLET && this.showInTablet)
    );
  }

  /**
   * Check if the data is valid, should throw an error if the input doesn't match designated fields
   * @param data
   */
  public validate(data: Carousel): boolean {
    if (!data.carouselImages) {
      throw new Error(
        `Invalid options for CarouselComponent ${data}: Required fields [carouselImages]`
      );
    }
    return true;
  }
}
